import { useState, type FormEvent } from "react";
import { Link } from "@tanstack/react-router";
import { api } from "@/lib/api";
import { Logo } from "@/components/logo";
import { girdi } from "./Giris";
import { cevir } from "@/lib/dil";
import { useVeri } from "@/lib/veri";

/** Kimlik telefondur (e-postayla giriş açık ortamda e-posta da); bağlantı kayıtlı e-postaya gider. Sonuç ekranı kasıtlı belirsiz: kimliğin kayıtlı olup olmadığını söylemez. */
export function SifremiUnuttum() {
  const { veri: secenek } = useVeri<{ epostaGiris: boolean }>("/auth/secenekler");
  const eposta = secenek?.epostaGiris === true;
  const [kimlik, setKimlik] = useState("");
  const [mesgul, setMesgul] = useState(false);
  const [bitti, setBitti] = useState(false);

  async function gonder(e: FormEvent) {
    e.preventDefault();
    setMesgul(true);
    await api.post("/auth/sifremi-unuttum", { kimlik }).catch(() => undefined);
    setBitti(true);
    setMesgul(false);
  }

  return (
    <main className="flex min-h-dvh items-center justify-center bg-bg p-4 font-plex">
      <div className="w-full max-w-sm rounded-xl border border-line bg-surface p-6 shadow-[var(--shadow-lg)]">
        <Logo height={24} />
        <h1 className="mt-3 text-lg font-semibold">{cevir("I forgot my password")}</h1>
        {bitti ? (
          <>
            <p className="mt-4 rounded-md bg-ok-bg p-4 text-base leading-relaxed text-ink">{cevir("If number is registered in system, password setting link has been sent to account's email address. Link is valid for")} <strong>{cevir("1 hour")}</strong> .</p>
            <p className="mt-3 text-sm leading-relaxed text-ink-3">{cevir("If email didn't arrive, your administrator (PM) can set your password manually or resend invitation.")}</p>
            <Link to="/" className="mt-5 block w-full rounded-md bg-navy px-4 py-2.5 text-center font-semibold text-white dark:text-[#0a141c]">{cevir("Return to login screen")}</Link>
          </>
        ) : (
          <form onSubmit={gonder}>
            <p className="mb-5 mt-1 text-base leading-relaxed text-ink-2">{eposta ? cevir("Enter your phone number or email; we will send the password setting link to the email address registered to your account.") : cevir("Enter your phone number; we will send the password setting link to the email address registered to your account.")}</p>
            <label className="mb-1 block text-base font-medium text-ink-2" htmlFor="kimlik-unuttum">{eposta ? cevir("Phone or email") : cevir("Phone")}</label>
            <input id="kimlik-unuttum" type={eposta ? "text" : "tel"} inputMode={eposta ? "email" : "numeric"} autoComplete="username" autoFocus placeholder={eposta ? "0554 178 17 74 · name@modoffshore.com" : "0554 178 17 74"} value={kimlik} onChange={(e) => setKimlik(e.target.value)} className={girdi} />
            <button type="submit" disabled={mesgul || !kimlik} className="mt-5 w-full rounded-md bg-navy px-4 py-2.5 font-semibold text-white disabled:opacity-40 dark:text-[#0a141c]">{mesgul ? cevir("Sending...") : cevir("Send link")}</button>
            <Link to="/" className="mt-2 block w-full rounded-md border border-line px-4 py-2.5 text-center text-base text-ink-2 hover:bg-surface-2">{cevir("Cancel")}</Link>
          </form>
        )}
      </div>
    </main>
  );
}
